<template>
  <!-- NOTIFICATIONS -->
  <!-- vs-trigger-click -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2 custom-icon-badge" :badge="totalNotifications > 999 ? 999 : totalNotifications" />

    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

      <div class="notification-top text-center p-5 bg-primary text-white">
        <template v-if="notifications.length != 0">
            <h3 class="text-white" >{{ totalNotifications  }} {{$t('new_plural_male')}}</h3>
            <p class="opacity-75">{{$t('notifications')}}</p>
        </template>
        <template v-else>
            <p class="opacity-75">{{$t('none_notifications_to_show')}}</p>
        </template>
      </div>

      <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings" :key="$vs.rtl">
        <ul class="bordered-items">
          <li v-for="(ntf,index) in notifications" :key="index" class="flex justify-between px-4 py-4 notification cursor-pointer" @click="redirectTo(ntf.url,{filter:ntf.status_id,module:ntf.module})">
            <div class="flex items-start" v-if="ntf.count > 0">
              <feather-icon :icon="ntf.icon" :svgClasses="[`text-${ntf.color}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
              <div class="mx-2">
                <span class="font-medium block notification-title" :class="[`text-${ntf.color}`]"> </span>
                <small>{{$t('there_is')}} <strong> {{ntf.count}} </strong> {{ntf.module}} {{$t('documents')}} {{ntf.title}}</small>
              </div>
            </div>
          </li>
        </ul>
      </component>

    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      totalNotifications:0
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    notifications() { return this.$store.state.notifications }
  },
  watch:{
    notifications(){
      let totalNotifications=0
      this.notifications.forEach(element => {
        totalNotifications += Number(element.count)
      });
      this.totalNotifications=totalNotifications
    }
  },
  methods: {
    redirectTo(path,params = null){
      if(params.module == 'EHS'){
        this.$store.dispatch('setGlobalEhsFilter',params.filter)
      }
      if(params.module == 'Compliance'){
        this.$store.dispatch('setGlobalComplianceFilter',params.filter)
      }
      if(params.module == 'Expenses'){
        this.$store.dispatch('setGlobalExpensesFilter',params.filter)
        console.log('global filter',params.filter);
      }
        console.log('redirect');
      if(this.$route.path != path){
        this.$router.push(path)
      }
    }
  }
}

</script>
<style scoped="css">
.custom-icon-badge>span.feather-icon-badge{
    width: 1.5rem !important;
    height: 1.5rem !important;

}
</style>
